import _reject from 'lodash/reject';
import _get from 'lodash/get';
import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.dialog;
const dialog = (state = initialSettings, action) => {
  switch (action.type) {
    // OPEN
    case types.OPEN_DIALOG:
      if (action.closeOthers) {
        return {
          ...state,
          list: [{
            open: true,
            props: action.props,
          }],
        };
      }
      return {
        ...state,
        list: [
          ...state.list,
          {
            open: true,
            props: action.props,
          },
        ],
      };
    // CLOSE
    case types.CLOSE_DIALOG:
      return {
        ...state,
        list: _map(state.list, (dialogElement) => (
          _get(dialogElement, 'props.component.type') === action.componentType ? {
            ...dialogElement,
            open: false,
          } : dialogElement)),
      };
    // FLUSH
    case types.FLUSH_DIALOG:
      return {
        ...state,
        list: _reject(state.list, (dialogElement) => (_get(dialogElement, 'props.component.type') === action.componentType)),
      };
    default:
      return state;
  }
};

export default dialog;



// WEBPACK FOOTER //
// ./reducers/app/dialog.js